import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  message: null,
  distributorInfo: null,
  distributors: [],
});

const { Types, Creators } = createActions({
  getDistributorInfoRequest: ['distributorId'],
  getDistributorInfoRequestSuccess: ['distributorInfo', 'selectedDistributorId'],
  getDistributorInfoRequestFailure: ['message'],

  getDistributorsListRequest: ['pageParams'],
  getDistributorsListRequestSuccess: ['distributors'],
  getDistributorsListRequestFailure: ['message'],

  resetDistributorInfo: null,
});

export const getDistributorInfoRequest = (state) => state.merge({ isLoading: true, message: null });
export const getDistributorInfoRequestSuccess = (state, { distributorInfo }) =>
  state.merge({ isLoading: false, distributorInfo });
export const getDistributorInfoRequestFailure = (state, { message }) => state.merge({ isLoading: false, message });

export const getDistributorsListRequest = (state) => state.merge({ isLoading: true, message: null });
export const getDistributorsListRequestSuccess = (state, { distributors }) =>
  state.merge({ isLoading: false, distributors });
export const getDistributorsListRequestFailure = (state, { message }) => state.merge({ isLoading: false, message });

export const resetDistributorInfo = (state) => state.merge({ distributorInfo: null });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_DISTRIBUTOR_INFO_REQUEST]: getDistributorInfoRequest,
  [Types.GET_DISTRIBUTOR_INFO_REQUEST_SUCCESS]: getDistributorInfoRequestSuccess,
  [Types.GET_DISTRIBUTOR_INFO_REQUEST_FAILURE]: getDistributorInfoRequestFailure,

  [Types.GET_DISTRIBUTORS_LIST_REQUEST]: getDistributorsListRequest,
  [Types.GET_DISTRIBUTORS_LIST_REQUEST_SUCCESS]: getDistributorsListRequestSuccess,
  [Types.GET_DISTRIBUTORS_LIST_REQUEST_FAILURE]: getDistributorsListRequestFailure,

  [Types.RESET_DISTRIBUTOR_INFO]: resetDistributorInfo,
});

export const DistributorsTypes = Types;
export default Creators;
